import React, {useState, useEffect} from "react";
import {Tooltip} from "./Tooltip";
import {Link} from "react-scroll";
import {useTranslation} from 'react-i18next';
import LanguageSelector from '.././utils/LanguageSelector';
import ResetZoomOnReload from ".././utils/ResetZoomOnReload";

const Header = ({classicHeader, darkTheme, homeRef, handleNavClick}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isNavModalClose, setIsNavModalClose] = useState(true);
    const {t} = useTranslation();

    ResetZoomOnReload();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        setIsMobile(mediaQuery.matches);

        const handleResize = (e) => setIsMobile(e.matches);
        mediaQuery.addListener(handleResize);
        return () => mediaQuery.removeListener(handleResize);
    }, []);

    const name = isMobile ? 'Alex Ballesteros' : 'Alejandro Ballesteros';

    return (
        <header id="header" className="sticky-top">
            {/* Navbar */}
            <nav className="primary-menu navbar navbar-expand-lg navbar-dark bg-dark border-bottom-0">
                <div className="container-fluid position-relative h-100 flex-lg-column ps-3 px-lg-3 pt-lg-3 pb-lg-2">
                    {/* Logo */}
                        <Link
                        smooth
                        duration={500}
                        style={{cursor: "pointer"}}
                        to="home"
                        className="mb-lg-auto mt-lg-4"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsNavModalClose(true);
                        }}
                    >
            <span className="bg-dark-2 rounded-pill p-2 mb-lg-1 d-none d-lg-inline-block">
              <img
                  className="img-fluid rounded-pill d-block"
                  src="images/profile.png"
                  title="Alejandro Ballesteros"
                  alt="Retrato de Alejandro Ballesteros"
                  width="160"
                  height="160"
              />
            </span>
                        <p className="text-5 text-white text-center d-lg-block mb-0">
                            {name}
                        </p>
                    </Link>
                    <div className="justify-content-center top-language-select"
                         style={{minWidth: '200px', marginLeft: '10px', marginRight: '10px', marginTop: '10px'}}>
                        <LanguageSelector/>
                    </div>
                    {/* Logo End */}


                    <div
                        id="header-nav"
                        className={
                            isNavModalClose
                                ? "collapse navbar-collapse w-100 my-lg-auto "
                                : "show navbar-collapse w-100 my-lg-auto"
                        }
                    >

                        <ul className="navbar-nav text-lg-center my-lg-auto py-lg-3">
                            <li className="nav-item">
                                <div className="bottom-language-select">
                                    <LanguageSelector/>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link
                                    target={homeRef}
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="home"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.home')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="about"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.about')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="services"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.my_work')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="resume"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.resume')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="portfolio"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.software_solutions')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="testimonial"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.coworkers')}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link "
                                    smooth
                                    duration={500}
                                    style={{cursor: "pointer"}}
                                    activeClass="active"
                                    spy
                                    to="contact"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsNavModalClose(true);
                                    }}
                                >
                                    {t('header.contact')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <ul className="social-icons social-icons-muted social-icons-sm mt-lg-auto ms-auto ms-lg-0 d-flex">
                        <li className="social-icons-facebook">
                            <Tooltip text="Facebook" placement="top">
                                <a
                                    href="https://www.facebook.com/softwaresolutionsmex"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-facebook-f"/>
                                </a>
                            </Tooltip>
                        </li>
                        <li className="social-icons-twitter">
                            <Tooltip text="Twitter" placement="top">
                                <a
                                    href="https://twitter.com/SoftwareSolutMx"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-twitter"/>
                                </a>
                            </Tooltip>
                        </li>
                        <li className="social-icons-youtube">
                            <Tooltip text="Youtube" placement="top">
                                <a
                                    href="https://www.youtube.com/@SoftwareSolutionsMexico"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-youtube"/>
                                </a>
                            </Tooltip>
                        </li>
                        <li className="social-icons-instagram">
                            <Tooltip text="Instagram" placement="top">
                                <a
                                    href="https://www.instagram.com/softwaresolutionsmx"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-instagram"/>
                                </a>
                            </Tooltip>
                        </li>
                    </ul>
                    <button
                        onClick={(e) => {
                            setIsNavModalClose(!isNavModalClose);
                        }}
                        className={
                            isNavModalClose ? "navbar-toggler" : "navbar-toggler show"
                        }
                        id="navbar-toggler"
                        type="button"
                    >
                        <span/>
                        <span/>
                        <span/>
                    </button>
                </div>
            </nav>
            {/* Navbar End */}
        </header>
    );
};

export default Header;
